/*
 * VatomInc. Copyright (c) 2022, all rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in the root directory of this source tree.
 */
/*
 * VatomInc. Copyright (c) ##[0-9]{4}##, all rights reserved.
 *
 * Licensed under the Vatom Inc SDK License (the "License"); you may not use this file or
 * the Vatom Inc SDK except in compliance with the License accompanying it. Unless
 * required by applicable law or agreed to in writing, the Vatom Inc SDK distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
/*
 * VatomInc2. Copyright (c) 2018, all rights reserved.
 *
 * Licensed under the Vatom Inc SDK License (the "License"); you may not use this file or
 * the Vatom Inc SDK except in compliance with the License accompanying it. Unless
 * required by applicable law or agreed to in writing, the Vatom Inc SDK distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
/*
 * VatomInc. Copyright (c) 2018, all rights reserved.
 *
 * Licensed under the Vatom Inc SDK License (the "License"); you may not use this file or
 * the Vatom Inc SDK except in compliance with the License accompanying it. Unless
 * required by applicable law or agreed to in writing, the Vatom Inc SDK distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

import { Platform } from 'react-native'

// Production config
export const defaultConfig = {
  //
  //  Project: Generic Web Viewer
  //
  // Your developer key. You can get one from developer.blockv.io
  appID: 'd9fd1482-3625-4746-854f-726b9032d4ff',

  // MapBox API Key. See https://docs.mapbox.com/mapbox-gl-js/overview/#quickstart to obtain a key
  mapBoxKey:
    'pk.eyJ1IjoiYXNoaXNoYXR2YXRvbWluYyIsImEiOiJjazlpdXR3M2YwMGNjM2xwcGE1ZDhqMm5jIn0.xBI8uwwTY1H-NOAgtTBvOg',
  // Google Maps Key
  googleMapsKey: 'AIzaSyAh5AGRqFcNj06Il0zeRd_huqDhPab11OI',
  // googleContactsClientID: '3679106328-shu3ek38ruqhii8nqusbjsj77b4on7d5.apps.googleusercontent.com',
  googleContactsClientID:
    '676578017431-8c4hnqbltbci6nv0j1moijhsl5s4u784.apps.googleusercontent.com',
  // Google Analytics Tracking ID
  analyticsTrackingID: 'G-BJ3MJ7C38R',
  // Catchoom Token for image recognition. See https://catchoom.com/image-recognition/ to obtain a token
  catchoomToken: '569feb87e2e94c6a',

  // defaultCampaignId: 'DJVCwpz2hK',

  geoLocationApi:
    'https://api.ipstack.com/check?access_key=f6c1392b737ae773c32e839ccd03e87f&fields=country_code,latitude,longitude',

  algoliaApiKey: 'be2a4102cb0d9d9d6e3cadd46dbf24dc',
  algoliaAppId: '1WB4E7CA90',

  // Default root for the web app router
  baseName: '/',

  // Firebase configuration options
  firebase: {
    apiKey: 'AIzaSyCyc4TsIcjIn4b8qDSOxM_CPpkd7Yaq0Qk',
    authDomain: 'generic-viewer.firebaseapp.com',
    databaseURL: 'https://generic-viewer.firebaseio.com',
    projectId: 'generic-viewer',
    storageBucket: 'generic-viewer.appspot.com',
    messagingSenderId: '73499331835',
    appId: '1:73499331835:web:f8f2e8b5688efe79'
  },
  // Firebase messaging VAPID key. See https://firebase.google.com/docs/cloud-messaging/js/client#generate_a_new_key_pair
  firebaseVapidKey:
    'BKVxCEXAz6fv-PP0B6ThsF56acxr4bJ14ku-LDZR-vb2LH4ejeeAvCaxGvq2YPpuVX6JWw80_6EE6XeLPwTiMGs',

  // Optional 8th wall app key, provides 6DoF movement in AR
  appKey8thWall: 'q6f9KSydWOgg0tZAqX7lKHT1kXBa8GNvgQqwxk6UGTadk8Io1pqPBUMt9HTlTLJx4d49lR',

  // authentication
  authentication: {
    clientId: Platform.OS === 'web' ? '94JHkdj8jF83jfFF2LI8Q4' : 'wallet-rn',
    useProxy: false,
    discoveryUrl: 'https://id.vatom.com',
    redirectUri: 'com.vatom://auth',
    scopes: ['openid', 'profile', 'email', 'offline_access']
  },
  // api
  api: {
    vatom: 'https://api.vi.vatom.network/v1/vatom',
    userVatom: 'https://api.vi.vatom.network/v1/user/vatom'
  },
  features: {
    maps: {
      // A single FQDN to whitelist. This performs filtering server-side.
      fqdn_whitelist: '',

      // Maximum vatoms to load in AR by default. Using a high number could cause crashes.
      max_items: 20,
      pickup: {
        enabled: true,
        redirect: 'ar'
      }
    }
  },
  tosLink: 'https://resources.vatom.com/system/terms/10172022/terms.pdf',
  privacyLink: 'https://resources.vatom.com/system/privacy/04212022/privacy-policy.pdf'
}
